import {Action} from '@ngrx/store';

export enum PrefetchDataActionTypes {
  PATHWAYS_TRIGGER_ON = '[Pathways] Trigger On',
  PATHWAYS_TRIGGER_OFF = '[Pathways] Trigger Off'
}


export class PathwaysTriggerOn implements Action {
  readonly type = PrefetchDataActionTypes.PATHWAYS_TRIGGER_ON;

}

export class PathwaysTriggerOff implements Action {
  readonly type = PrefetchDataActionTypes.PATHWAYS_TRIGGER_OFF;
}


export type PathwaysTrigger =
  PathwaysTriggerOn |
  PathwaysTriggerOff;
